import { Component, OnInit, Output, EventEmitter, Input, Inject } from '@angular/core';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-common-item',
    templateUrl: './common-item.shared.component.html',
    styleUrls: ['./common-item.shared.component.scss']
})
export class CommonItemComponent implements OnInit {
    @Input() public title: string;
    @Input() public description: string;
    @Input() public subDescription: string;
    @Input() public edit: boolean = false;
    @Input() public quantity: number = null;
    @Input() public total: number = null;
    @Input() public bottomPadding: boolean = false;
    @Input() public selectable: boolean = false;
    @Input() public selected: boolean = false;

    @Output() public onEditClick: EventEmitter<Event> = new EventEmitter();

    /* For quantity */
    @Input() public mode: OLO.Components.Quantity.QUANTITY_MODE = 'mini';
    @Input() public max: number = 9999;
    @Input() public remove: boolean = true; /* Show remove when quantity equals 1 */
    @Input() public minimumHide: boolean = false; /* Hide decrement / remove button when quantity equals 1 */
    @Input() public size: OLO.Components.BUTTON_SIZE;
    @Input() public disabled: boolean = false;
    @Input() public canDecrement: boolean = true; /* Can override components calculations */
    @Input() public canIncrement: boolean = true; /* Can override components calculations */

    @Output() public onDecrement: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onIncrement: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onRemove: EventEmitter<OLO.Components.Quantity.IQuantityOutputEvent> = new EventEmitter();
    @Output() public onEdit: EventEmitter<Event> = new EventEmitter();
    @Output() public onSelected: EventEmitter<Event> = new EventEmitter();
    @Output() public onDeselected: EventEmitter<Event> = new EventEmitter();

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
    ) { }

    ngOnInit(): void {
    }

    public handleIncrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.onIncrement.emit($event);
    }

    public handleDecrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.onDecrement.emit($event);
    }

    public handleRemove($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.onRemove.emit($event);
    }

    public handleEdit($event: Event): void {
        this.onEdit.emit($event);
    }

    public handleSelected($event: Event): void {
        this.onSelected.emit($event);
    }

    public handleDeselected($event: Event): void {
        this.onDeselected.emit($event);
    }
}
